'use strict';

import animationsUtility from '../utility/animations.js';

const animateHeaderLogo = () => {
    const header = document.getElementById('main-header');
    const paths = header.querySelectorAll('svg.tc-website-logo path.green');

    animationsUtility.animateLogo(paths);
}

const animateMegaMenuLogo = (reverse = false) => {
    const megaMenu = document.querySelector('.tc-website-megamenu');
    const paths = megaMenu.querySelectorAll('svg.tc-website-logo path.green');
    let pathsColor = 'var(--color-primary-200)';
    let duration = .7;
    let stagger = .08;

    if (reverse) {
        pathsColor = 'var(--color-gray-50)';
        duration = .1;
        stagger = .01;
    }

    animationsUtility.animateLogo(paths, pathsColor, duration, stagger);
}

export default {animateHeaderLogo, animateMegaMenuLogo}
